import { NgModule } from '@angular/core';
import { AddMessageComponent } from './add-message/add-message.component';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { NGFontAwesomeModule } from '../global/ngfontawesome.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PrimengModule } from '../global/primeng.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../core';
import { PropertyModule } from '../property/property.module';
import { SharedModule } from 'primeng/shared';

@NgModule({
  declarations: [AddMessageComponent],
  imports: [ CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NGFontAwesomeModule,
    FontAwesomeModule,
    PrimengModule,
    FormsModule,
    CoreModule,
    PropertyModule,
    SharedModule,
    ReactiveFormsModule
    ], exports: [AddMessageComponent]
})
export class MessageModule { }
